export default {
  name: 'dn-panel-link-group',

  props: {
    category: {
      type: String,
      required: true,
    },
    group: {
      type: String,
      required: true,
    },
  },

  computed: {
    computedGroup() {
      return this.$store.getters['navigation/categoryGroup'](this.category, this.group);
    },
    computedLinks() {
      const group = this.computedGroup;
      if (!group) return [];

      return group.links.slice().sort((a, b) => {
        if (a.created && b.created) {
          if (a.created.timestamp > b.created.timestamp) return -1;
          if (a.created.timestamp < b.created.timestamp) return 1;
          return -1;
        }
        if (a.created) return -1;
        if (b.created) return 1;
        return 0;
      });
    },
  },

  render(h) {
    const group = this.computedGroup;
    if (!group) return;

    const links = this.computedLinks;
    const { label } = group;
    const $children = [];

    if (this.title) {
      $children.push(h('h3', {
        staticClass: 'dn-link-group__title',
        class: {
          'dn-heading-3': this.isList,
        },
        domProps: {
          innerHTML: label + (this.isBlock ? ' 関連ページ' : ''),
        },
      }));
    }

    const $links = links.filter(link => {
      return !link.data.groupIndex && link.data.groupIndex !== '';
    }).map(link => {
      const updateChildren = [
        link[link.publishState].fullLabel + ' ' +(link.publishState === 'created' ? '公開' : '更新'),
      ];

      // if (link.created.latest) {
      //   updateChildren.push(h('span', {
      //     staticClass: 'dn-panel-link-group__update-new',
      //   }, 'NEW'));
      // }

      const $update = link.publishState ? h('span', {
        staticClass: 'dn-panel-link-group__update-label',
        // class: {
        //   'dn-panel-link-group__update-latest': link.created.latest,
        // },
      }, updateChildren) : null;

      const $icon = h('span', {
        staticClass: 'dn-panel-link-group__icon',
      }, [h('dn-icon', { props: { icon: 'arrow-right' } })])

      const $label = h('span', {
        staticClass: 'dn-panel-link-group__label',
        domProps: {
          innerHTML: link.label,
        },
      });

      const $title = h('div', {
        staticClass: 'dn-panel-link-group__ttl',
      }, [$icon, $label]);

      const $tags = link.tags ? link.tags.map((tag, index) => {
        tag = typeof tag === 'string' ? { color: 'default', text: tag } : tag;
        return h('dn-navigation-tag', {
          props: {
            tag: 'li',
            color: tag.color,
          },
          key: index,
        }, tag.text);
      }) : null;

      const infoChildren = [$update];
      if ($tags) {
        infoChildren.unshift(h('ul', {
          staticClass: 'dn-panel-link-group__tags',
        }, $tags));
      }

      const $info = h('div', {
        staticClass: 'dn-panel-link-group__info',
      }, infoChildren);

      const domProps = {
        href: link.href,
      };

      if (link.target) {
        domProps.target = link.target;
      }

      const linkChildren = [$title, $info];

      return h('a', {
        staticClass: 'dn-panel-link-group__link',
        domProps,
      }, linkChildren);
    });

    return h('nav', {
      staticClass: 'dn-panel-link-group',
    }, $links);
  },
}



// WEBPACK FOOTER //
// ./src/js/ui/components/navigations/PanelLinkGroup.js